import { ReactNode, useId } from 'react';
import cn from 'classnames';
import classes from './SettingsSection.module.css';

type SettingsSectionProps = {
  title: string;
  description?: string;
  /** Shown next to the heading, e.g. an add button */
  action?: ReactNode;
  variant?: 'default' | 'danger';
  headingId?: string;
  children?: ReactNode;
};

/** A white settings card with a heading and a short description. */
export const SettingsSection = ({
  title,
  description,
  action,
  variant = 'default',
  headingId,
  children,
}: SettingsSectionProps) => {
  const generatedId = useId();
  const titleId = headingId ?? generatedId;

  return (
    <section
      aria-labelledby={titleId}
      className={cn(classes.section, {
        [classes.danger]: variant === 'danger',
      })}
    >
      <div className={classes.header}>
        <div className={classes.intro}>
          <h2 id={titleId} className={classes.title}>
            {title}
          </h2>
          {description && <p className={classes.description}>{description}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
};
